import { render, staticRenderFns } from "./dynamic-ledger-comparison.vue?vue&type=template&id=039b4c81"
import script from "./dynamic-ledger-comparison.vue?vue&type=script&lang=js"
export * from "./dynamic-ledger-comparison.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports